import React from 'react'
import InputOutputHandler from './InputOutputHandler'
import ExternalHooksHandler from './ExternalHooksHandler'

const GlobalProvider = ({ instanceId, children }): JSX.Element => {
  return (
    <React.Fragment>
      <InputOutputHandler instanceId={instanceId} />
      <ExternalHooksHandler instanceId={instanceId} />
      {children}
    </React.Fragment>
  )
}

export default GlobalProvider
